import { useContext } from "react";

import { PlacementsContext } from "../PlacementsContext";

/**
 * Determines whether or not placement content has finished loading.
 * @returns An object whose sole property is contentHasLoaded which determines the
 *  loading status of the placement content.
 */
export const useContentLoadingStatus = () => {
  const { complete } = useContext(PlacementsContext);

  return { contentHasLoaded: complete?.current?.ok };
};
